export enum fetchLabelsActions {
  Request = 'FETCH_LABELS_REQUEST',
  Success = 'FETCH_LABELS_SUCCESS',
  Failed = 'FETCH_LABELS_FAILED',
}

export enum deleteLabelsActions {
  Request = 'DELETE_LABELS_REQUEST',
  Success = 'DELETE_LABELS_SUCCESS',
  Failed = 'DELETE_LABELS_FAILED',
}

export enum addLabelsActions {
  Request = 'ADD_LABELS_REQUEST',
  Success = 'ADD_LABELS_SUCCESS',
  Failed = 'ADD_LABELS_FAILED',
}
